import request from "@/utils/request";

export default function list() {
    return request({
        url: `/storeMarketPlace/agency/list`,
        method: 'get',
    })
}
